import styled from 'styled-components';

export default function ColorCustomInput(props) {
  const { value, setValue, placeholder, width, disabled, textAlign, color } = props;

  function handleClick(e) {
  }

  function handleChange(e) {
    setValue(e.target.value);
  }

  function handleFocus(e) {
  }

  function handleBlur(e) {
  }

  return (
    <Input
      type='text'
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      textAlign={textAlign}
      width={width}
      color={color}
      onClick={handleClick}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur} />
  )
}

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	width: ${props => props.width}px;
	height: 30px;

	padding: 0 8px;

	outline: none;
	border: 1px solid ${props => props.color};
	border-radius: 5px;
	color: ${props => props.color};

  text-align: ${props => props.textAlign};

	::placeholder {
		color: ${props => props.disabled ? `#FFFFFF` : `#CBCBCB`};
	}
  
  &:disabled {
    background-color: #CBCBCB;
    color: #FFFFFF; 
    cursor: not-allowed;
  }
	
  transition: all 0.3s ease-in-out;
`;